import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Menu, { MenuItem } from 'components/common/Menu';

const styles = () => ({
  menuItem: {
    display: 'flex',
    justifyContent: 'space-between',
    minWidth: 272,
    borderTop: 'none',
    paddingTop: 8,
    paddingBottom: 8,
  },
});

const OrderInformationSalesRepresentativeMenu = ({
  open,
  anchorEl,
  id,
  onClose,
  onAddButtonClick,
  onItemClick,
  classes,
  ...otherProps
}) => (
  <Menu
    id={id}
    anchorEl={anchorEl}
    open={open}
    {...onClose ? { onClose } : {}}
    onListAdornmentClick={onAddButtonClick}
    listAdornmentText="Add From List"
  >
    {otherProps['Sales Representative'].map(item => (
      <MenuItem
        className={classes.menuItem}
        key={item.ID}
        {...onItemClick ? { onClick: () => { onItemClick(item); } } : {}}
      >
        <Typography component="span">
          {item['First Name']} {item['Last Name']}
        </Typography>
      </MenuItem>
    ))}
  </Menu>
);

OrderInformationSalesRepresentativeMenu.propTypes = {
  open: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  anchorEl: PropTypes.object,
  id: PropTypes.string,
  onClose: PropTypes.func,
  'Sales Representative': PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
    'First Name': PropTypes.string,
    'Last Name': PropTypes.string,
  })),
  onItemClick: PropTypes.func,
  onAddButtonClick: PropTypes.func,
  classes: PropTypes.shape({
    menuItem: PropTypes.string.isRequired,
  }).isRequired,
};

OrderInformationSalesRepresentativeMenu.defaultProps = {
  open: false,
  anchorEl: null,
  id: null,
  onClose: null,
  'Sales Representative': [],
  onItemClick: null,
  onAddButtonClick: null,
};

export default withStyles(styles)(OrderInformationSalesRepresentativeMenu);



// WEBPACK FOOTER //
// ./src/components/workflow/OrderInformation/OrderInformationSalesRepresentative/OrderInformationSalesRepresentativeMenu.js